import {Validator} from 'vee-validate';
import {BasicSelect} from 'vue-search-select';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../../shared/components/loader';
import CONSTANT from './../../../../../shared/constants/constant';
import DatePicker from 'vue2-datepicker';
import Pagination from './../../../../../shared/components/pagination'
import moment from 'moment';
import Util from './../../../../../shared/util/util'
import TripServices from './../../../../services/firstAndLastmilemanagement.service'

export default {
  name: 'otherConfiguration',
  components: {
    BasicSelect,
    VueElementLoading,
    DatePicker,
    moment,
    Pagination,
    Loader
  },
  data() {
    return {
    UADrescheduledays:'',
    Consigneereason:'',
    Operationsreason:'',
    UADCutOffTime:'',
    currentUADrescheduledays: '',
    currentConsigneereason:'',
    currentOperationsreason:'',
    showflag : false,
    isLoading:false,
    forcemajurereason:'',
    currentforcemajurereason:''
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = parseInt(userdetail.userid);
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.isLoading = false;
    await this.GetConfigvalue()

  },
  methods: {
    async MarkOtherConfiguration() {
      try {
        if(this.checkErr()){
          return false
        }
        this.isLoading = true;
        let InputPayload = {
          currentuadrescheduledays:this.currentUADrescheduledays,
          currentuadmaxattemptconsignee : this.currentConsigneereason,
          currentuadmaxattemptoperation : this.currentOperationsreason,
          uadrescheduledays: this.UADrescheduledays,
          uadmaxattemptconsignee:this.Consigneereason,
          uadmaxattemptoperation:this.Operationsreason,
          currentuadmaxattemptforcemajure:this.currentforcemajurereason,
          uadmaxattemptforcemajure:this.forcemajurereason,
        };
        let response = await TripServices.MarkOtherConfiguration(InputPayload);
        if(response.data.code===200){
          this.isLoading = false;
          this.UADrescheduledays = ''
          this.Consigneereason = ''
          this.Operationsreason = ''
          this.GetConfigvalue()
          this.$alertify.success(response.data.message);
        }
        else {
          this.$alertify.error(response.data.message);
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async GetConfigvalue() {
      try {
        this.isLoading = true;
        let InputPayload = {
         key : "UADCONFIG"
        };
        let response = await TripServices.GetAdminSettingconfig(InputPayload);
        if(response.data.code===200){
          this.isLoading = false;
          this.currentUADrescheduledays = response.data.data.uadrescheduledays
          this.currentConsigneereason = response.data.data.uadmaxattemptconsignee
          this.currentOperationsreason = response.data.data.uadmaxattemptoperation
          this.currentforcemajurereason = response.data.data.uadmaxattemptforcemajure
          this.showflag = true
        }
        else {
          this.$alertify.error(response.data.message);
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    checkErr(){
      let err = false
      if(this.UADrescheduledays == '' && this.Consigneereason == ''  && this.Operationsreason == '' && this.forcemajurereason == ''){
        err = true
        this.$alertify.error("Please enter value in atleast one field")
      }
      if(this.UADrescheduledays!= '' && !this.UADrescheduledays.match(/^[1-9]\d*$/)){
        this.$alertify.error("Max days for UAD re-schedule should be a Number and greater than zero")
        err = true
      }
      if(this.Consigneereason!='' && !this.Consigneereason.match(/^[1-9]\d*$/)){
        this.$alertify.error("Max UAD Attempt should be a Number and greater than zero")
        err = true
      }
      if(this.Operationsreason!=''  && !this.Operationsreason.match(/^[1-9]\d*$/)){
        this.$alertify.error("Max UAD Attempt should be a Number and greater than zero")
        err = true
      }
      if(this.forcemajurereason!=''  && !this.forcemajurereason.match(/^[1-9]\d*$/)){
        this.$alertify.error("Max UAD Attempt should be a Number and greater than zero")
        err = true
      }
      return err
    },
clearForm(){},
selectfacilitytype(){},
selectCutOffTime(){},
selectUADCutOffTime(){},
selectCutOffTime(){},
getCustomTableEvent(){}

  }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/UADConfiguration/otherConfiguration/otherConfiguration.component.js